










































import Vue from "vue";
import { Tutor } from "../types";
import TutorCertification from "./TutorCertification.vue";
import TutorHeadShot from "./TutorHeadShot.vue";
// import TutorSpecialAvailability from "./TutorSpecialAvailability.vue";
import TutorDisplayName from "./TutorDisplayName.vue";
import TutorLocation from "./TutorLocation.vue";
import { nl2br } from "../utils";

export default Vue.extend({
  props: {
    tutor: {
      type: Object as () => Tutor,
      required: true
    },
    tagName: {
      type: String,
      required: false,
      default: (): string => "a"
    }
  },

  computed: {
    posessiveFirstName(): string {
      const output = this.tutor.first_name;

    //   if (output.substr(-1) === "s") {
    //     return "${output}'";
    //   }

      return `${output}'s`;
    },

    hasAnySocialLinks(): boolean {
      return Boolean(
        this.tutor.linkedin_url ||
          this.tutor.twitter_url ||
          this.tutor.facebook_url ||
          this.tutor.youtube_url
      );
    },

    imageSource(): string {
      return (
        this.tutor.picture_url || require("../images/photo-placeholder.svg")
      );
    },

    displayName(): string {
      return `${this.tutor.first_name} ${this.tutor.last_initial}.`;
    }
  },

  methods: {
    nl2br
  },

  components: {
    TutorHeadShot,
    TutorCertification,
    TutorDisplayName,
    TutorLocation
  }
});
